import { ILSContent, ILSHeader, ILSLayout, ILSTitle } from '@components/index';
import { Scope } from '@core/containers/scope';
import { ModuleScope } from '@core/types';
import { FC } from 'react';
import CustomScroll from 'react-customscroll';

const LimitedPage: FC = () => {
  return (
    <ILSLayout className="ils-wrapper">
      <ILSHeader>
        <div className="flex-between-center">
          <Scope name={ModuleScope.Logo} />
          <Scope name={ModuleScope.HeaderRight} />
        </div>
      </ILSHeader>
      <ILSContent className="ils-content">
        <CustomScroll>
          <div className="flex-center-start p-5">
            <div className="bg-white rounded p-5">
              <ILSTitle title={'Ограниченный доступ'} />
              <div className="py-3">
                <p>К сожалению, роль Вашего аккаунта не позволяет пользоваться системой.</p>
                <p>Пожалуйста, обратитесь к администратору аккаунта.</p>
              </div>
            </div>
          </div>
        </CustomScroll>
      </ILSContent>
    </ILSLayout>
  );
};

export default LimitedPage;
